module.exports = __webpack_public_path__ + "img/mail.1a885277.png";